export const Links = {
    termsOfService: 'https://genasys.com/website-terms-conditions/',
    SLA: 'https://genasys.com/saas-services-agreement/',
    privacyPolicy: 'https://genasys.com/privacy-policy/',

    helpCenter: 'https://gethelp.genasys.com/help-center/category/pt/connect/',
    helpSecurePassword: 'https://gethelp.genasys.com/help-center/choosing-a-secure-password-connect/',
    helpCenterNotifications: 'https://gethelp.genasys.com/help-center/category/connect/notifications/',
    cookiesHelp: 'http://lexisnexis.custhelp.com/app/answers/answer_view/a_id/1084175/~/enable-cookies-in-most-common-internet-browsers',

    contactUs: 'https://genasys.com/contact-us/',

    helpConnectors: 'https://gethelp.genasys.com/help-center/external-connecting-rooms-evertel/'
}
